<script lang="ts">
  type Size = 'xs' | 'sm' | 'md' | 'feed' | 'lg';

  let {
    username,
    avatarUrl = null,
    size = 'sm' as Size,
  }: { username: string; avatarUrl?: string | null; size?: Size } = $props();

  const sizeMap: Record<Size, number> = { xs: 22, sm: 40, md: 54, feed: 40, lg: 64 };
  const dim = $derived(sizeMap[size]);
</script>

{#if avatarUrl}
  <img
    src={avatarUrl}
    alt=""
    loading="lazy"
    width={dim}
    height={dim}
    class="avatar"
    style="width:{dim}px;height:{dim}px"
  />
{:else}
  <span
    class="avatar-placeholder"
    class:avatar--xs={size === 'xs'}
    style="width:{dim}px;height:{dim}px;font-size:{dim < 30 ? '0.6rem' : dim < 50 ? '0.875rem' : '1.25rem'}"
  >
    {(username ?? '?').charAt(0).toUpperCase()}
  </span>
{/if}

<style>
  .avatar {
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    border: 2px solid var(--purple);
  }
  .avatar--xs {
    border-width: 1px;
  }
  .avatar-placeholder {
    border-radius: 50%;
    flex-shrink: 0;
    background: linear-gradient(135deg, var(--pink), var(--purple));
    border: 2px solid var(--purple);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: var(--text);
    user-select: none;
  }
  .avatar-placeholder.avatar--xs {
    border-width: 1px;
  }
</style>
